var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_237_5029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 19,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78812 9.47131C2.58551 9.47131 2.3912 9.39082 2.24793 9.24755C2.10466 9.10429 2.02417 8.90997 2.02417 8.70736V2.59727C2.02417 2.39465 2.10466 2.20034 2.24793 2.05707C2.3912 1.9138 2.58551 1.83331 2.78812 1.83331H8.89974C9.10236 1.83331 9.29667 1.9138 9.43994 2.05707C9.58321 2.20034 9.6637 2.39465 9.6637 2.59727V8.70736C9.6637 8.90997 9.58321 9.10429 9.43994 9.24755C9.29667 9.39082 9.10236 9.47131 8.89974 9.47131H2.78812ZM13.4835 9.47131C13.2808 9.47131 13.0865 9.39082 12.9433 9.24755C12.8 9.10429 12.7195 8.90997 12.7195 8.70736V2.59727C12.7195 2.39465 12.8 2.20034 12.9433 2.05707C13.0865 1.9138 13.2808 1.83331 13.4835 1.83331H19.5935C19.7962 1.83331 19.9905 1.9138 20.1337 2.05707C20.277 2.20034 20.3575 2.39465 20.3575 2.59727V8.70736C20.3575 8.90997 20.277 9.10429 20.1337 9.24755C19.9905 9.39082 19.7962 9.47131 19.5935 9.47131H13.4835ZM2.78812 20.1666C2.58551 20.1666 2.3912 20.0862 2.24793 19.9429C2.10466 19.7996 2.02417 19.6053 2.02417 19.4027V13.2911C2.02417 13.0885 2.10466 12.8941 2.24793 12.7509C2.3912 12.6076 2.58551 12.5271 2.78812 12.5271H8.89974C9.10236 12.5271 9.29667 12.6076 9.43994 12.7509C9.58321 12.8941 9.6637 13.0885 9.6637 13.2911V19.4027C9.6637 19.6053 9.58321 19.7996 9.43994 19.9429C9.29667 20.0862 9.10236 20.1666 8.89974 20.1666H2.78812ZM13.4835 20.1666C13.2808 20.1666 13.0865 20.0862 12.9433 19.9429C12.8 19.7996 12.7195 19.6053 12.7195 19.4027V13.2911C12.7195 13.0885 12.8 12.8941 12.9433 12.7509C13.0865 12.6076 13.2808 12.5271 13.4835 12.5271H19.5935C19.7962 12.5271 19.9905 12.6076 20.1337 12.7509C20.277 12.8941 20.3575 13.0885 20.3575 13.2911V19.4027C20.3575 19.6053 20.277 19.7996 20.1337 19.9429C19.9905 20.0862 19.7962 20.1666 19.5935 20.1666H13.4835Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_237_5029)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.190842,
    y: -0.00109863,
    width: 22,
    height: 22,
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.9224a19aa0ff73912be9b21ada192e59.svg";
export { ForwardRef as ReactComponent };